import { unwrapResult } from "@reduxjs/toolkit";
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../state/store";
import { getAuthUserInfoAction } from "../../state/usecase/auth/actions";

// 参考1...https://reactrouter.com/web/example/auth-workflow
// 参考2...https://usehooks.com/useAuth/

export enum RegistrationStatus {
    PENDING = "pending",
    REGISTERED = "registered",
    UNREGISTERED = "unregistered"
}

export const useRegistrationStatus = (): RegistrationStatus => useContext(RegistrationStatusContext);

export const RegistrationStatusContext = createContext<RegistrationStatus>(RegistrationStatus.PENDING);

type Props = {
    children: ReactNode,
};

export const RegistrationStatusProvider = (props: Props) => {
    const { children } = props;
    
    const [registrationStatus, setRegistrationStatus] = useState<RegistrationStatus>(RegistrationStatus.PENDING);

    const dispatch = useAppDispatch();

    useEffect( () => {
        // https://stackoverflow.com/questions/67127694/typescript-correct-typing-for-return-type-of-asyncthunk-when-using-unwrapresul
        dispatch(getAuthUserInfoAction())
            .then(unwrapResult)
            .then((_originalPromiseResult: any) => {
                setRegistrationStatus(RegistrationStatus.REGISTERED);
            })
            .catch((_rejectedValueOrSerializedError: any) => {
                setRegistrationStatus(RegistrationStatus.UNREGISTERED);
            });

    }, [dispatch]);

    return <RegistrationStatusContext.Provider value={registrationStatus}>{ children }</RegistrationStatusContext.Provider>;
};
